import { useEffect } from 'react';
import {certificatesValidationApi} from '../api/certificatesValidation.api'
import { CERTIFICATES_STATUS } from '../../../interaces/certificates_types.interface';
import { formatOptionsForSelect } from '../../../services/helpers';
import { useCertificateTypes } from '../../certificate-types/hooks/useCertificateTypes';
import { useDataTable } from '../../../hooks/useDataTable';
export const useCertificatesValidation = () => {
 const table = useDataTable(certificatesValidationApi);
   const {
     setDataFilters,
   } = table;
    const {
    names,getNames
  } = useCertificateTypes();

  useEffect(() => {
      getNames()
  }, []);
  useEffect(() => {
    setDataFilters([
      {
      filter: 'certificateType',
      value_filter: '',
      data: formatOptionsForSelect(names, 'name', 'name', 'Elegir tipo'),
      width: 'col-span-4 max-[768px]:col-span-12',
    },
      {
        filter: 'status',
        value_filter: '',
        data: CERTIFICATES_STATUS,
        width: 'col-span-3 max-[768px]:col-span-12',
      },
    ]);
  }, [names]);

   return {
    ...table
  };
};
